const https = require("https");
const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

module.exports = function getFetchAgent() {
	return new https.Agent({
		rejectUnauthorized: generalSettings.data.siteMetaData.is_production,
	});
};
